import { Modal, TextField, Button } from '@mui/material';
import { Footer, ModalBox, ModalH2 } from '../../../Styles/ModalStyle';
import { Field, Formik, Form } from 'formik';
import { toast } from 'react-toastify';
import ContaReceberController from '../../../../controllers/ContaReceberController';
import BoletoController from '../../../../controllers/BoletoController';

interface ModalProps {
    open: boolean;
    onClose: () => void;
    values: any;
    onSuccess: () => void;
}

const ModalEditarParcela = ({ open, onClose, values, onSuccess }: ModalProps) => {

    const getInitialValues = () => {
        const item = values?.selectedItem?.Item || values?.selectedItem;

        if (!item) return { cre_id: '', vencimento: '' };
        let dataFormatada = '';
        if (item.dataVencimento) {
            try {
                // Garante que é uma string válida antes de criar o Date
                const dataString = String(item.dataVencimento);
                // Pega apenas a parte YYYY-MM-DD
                dataFormatada = new Date(dataString).toISOString().split('T')[0];
                console.log('Data Formatada:', dataFormatada);
            } catch (e) {
                console.error('Erro ao formatar data:', e);
            }
        }

        return {
            cre_id: item.cre_id || '',
            vencimento: dataFormatada
        };
    };

    const handleSave = async (formValues: any, { setSubmitting }: any) => {

        const request = {
            codigo: formValues.cre_id,
            vencimento: formValues.vencimento
        };

        try {
            if (values?.selectedItem?.boletoGerado) {
                const res = await BoletoController.Alterar({
                    creId: formValues.cre_id,
                    novaData: formValues?.vencimento?.split('-')?.reverse()?.join('.') || ''
                })
                if (!(res.StatusCode && res.StatusCode >= 200 && res.StatusCode < 300)) return toast.error('Erro em alterar vencimento de Boleto em Banco do Brasil')
            }
            const response = await ContaReceberController.Atualizar(request);

            if (response.StatusCode === 200 || response.StatusCode === 204) {
                toast.success('Data da parcela atualizada com sucesso!');
                onSuccess();
                onClose();
            } else {
                toast.error('Erro ao atualizar a parcela!');
            }
        } catch (error) {
            console.error('Erro na requisição:', error);
            toast.error('Ocorreu um erro ao tentar salvar.');
        }
        setSubmitting(false);
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
            <ModalBox>
                <ModalH2>Editar Vencimento</ModalH2>
                <Formik
                    initialValues={getInitialValues()}
                    enableReinitialize={true}
                    onSubmit={handleSave}
                >
                    {({ handleSubmit }) => (
                        <Form>
                            <div className="flex flex-col gap-4 mt-4">
                                <Field
                                    name='cre_id'
                                    as={TextField}
                                    label='Pedido'
                                    type='number'
                                    fullWidth
                                    disabled
                                    variant="outlined"
                                />

                                <Field
                                    name='vencimento'
                                    as={TextField}
                                    label='Vencimento'
                                    InputLabelProps={{ shrink: true }}
                                    type='date'
                                    fullWidth
                                    variant="outlined"
                                />
                            </div>

                            <Footer>
                                <Button onClick={onClose} color='error'>
                                    Cancelar
                                </Button>
                                <Button onClick={() => handleSubmit()} variant='contained' color='primary'>
                                    Salvar
                                </Button>
                            </Footer>
                        </Form>
                    )}
                </Formik>
            </ModalBox>
        </Modal>
    );
};

export default ModalEditarParcela;